// Port of api/fuel/app/classes/insights/players/specialised.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'specialised',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: false,
	detail: ['specialised'],
	run: function(type, owner, userIndex, detail) {
		var data = {
			specialised: [],
			total: 0
		}
		var players = this._data.players || []
		var limit = detail ? 250 : 5

		for (var i = 0; i < players.length; i++) {
			Object.keys(players[i].gameCounts || {}).forEach(function(gameId) {
				data.specialised.push({
					id: parseInt(players[i].id, 10) || 0,
					slug: players[i].slug,
					fullname: 'Game Name',
					name: players[i].primaryName,
					username: players[i].username,
					count: parseInt(players[i].gameCounts[gameId], 10) || 0,
					game: parseInt(gameId, 10) || 0
				})
			})
		}

		data.total = data.specialised.length
		data.specialised = data.specialised.slice().sort(function(a, b) { return (b.count || 0) - (a.count || 0) || (a.game || 0) - (b.game || 0) })
		if (data.specialised.length > limit) data.specialised = data.specialised.slice(0, limit)

		for (var j = 0; j < data.specialised.length; j++) {
			this._references.games.push(parseInt(data.specialised[j].game, 10) || 0)
		}

		return {
			specialised: data
		}
	}
})
